<div class="">
  <div class="tabs">
    <span class="tablinks" style="font-weight: bold;" id="defaultOpen">Analytics dashboard</span>
  </div>
  <div class="" *ngIf="mainSelectedTab ==='contentAnalytics'">
    <div class="tabs tabBlue tabReport">
      <span class="tablinks active" (click)="tabopen('last24hours')" [class.active]="selectedTab === 'last24hours'">Last
        24 hours</span>
      <span class="tablinks" (click)="tabopen('last30days')" [class.active]="selectedTab === 'last30days'"> Last 30
        days</span>
      <span class="tablinks" (click)="tabopen('daterange')" [class.active]="selectedTab === 'daterange'"> Custom 
        Daterange</span>
    </div>
  </div>
</div>
<div *ngIf="mainSelectedTab ==='contentAnalytics'" class="pageContainer tabcontent pageList elementList reportPanel" id="page" style="display:block;">
  <div class="tabcontainer">
    <div  *ngIf="showLoader">
      <div class="imagepreloader">
        <div class="a" style="--n: 5;">
          <div class="dot dot1" style="--i: 0;"></div>
          <div class="dot dot2" style="--i: 1;"></div>
          <div class="dot dot3" style="--i: 2;"></div>
          <div class="dot dot4" style="--i: 3;"></div>
        </div>
      </div>
    </div> 
    <div *ngIf="selectedTab==='daterange'">
    <h4>Generate Custom Analytics</h4>
        <div class="reportFilter">
          <ul>
            <li>
             <span class="tab">  
               <span id="mydate" name="daterangeInput" daterangepicker [options]="options" (selected)="selectedDate($event, daterangepicker)"
                   (cancelDaterangepicker)="calendarEventsHandler($event, daterangepicker)" (applyDaterangepicker)="calendarEventsHandler($event, daterangepicker)">
                   <ng-container *ngIf="!chosenDate">
                    Select Date Range
                   </ng-container>
                   <ng-container *ngIf="chosenDate">
                    {{getNewTypeDateRange(chosenDate.beginEpoc)}} -  {{getNewTypeDateRange(chosenDate.endEpoc)}}
                   </ng-container>
                   <!-- {{chosenDate? '{{({{getNewTypeDateRange(chosenDate.beginEpoc)}} -  {{getNewTypeDateRange(chosenDate.endEpoc)}}.dateFrom)}} -  {{(item.dateTo)}}' : 'Select Date Range'}} -->
                   <i class="icon-arrow"></i></span>
                     </span>         
            </li>
          </ul>
            <button class="generatebtn" name="revertCard" type="button" (click)="generateReport()">Generate Data</button>
        </div> 
      </div> 
    <div class="analyticList" *ngIf="flag">
      <h4 class="sum_head">Summary</h4>
      <ul>
        <li><b>Stories filed - </b><span class="digit1">{{summary.totalStoriesPublished}}</span></li>
        <li><b>Stories Notified - </b><span class="digit1">{{summary.totalStoriesNotified}}</span></li>
        <li>Stories with Auto Backlinks - <span class="digit1">{{summary.storiesWithAutoBacklink}}</span></li>
        <li>Text - <span class="digit1">{{summary.textStoriesPublished}}</span> </li>
        <li>Web - <span class="digit1">{{summary.webStoriesNotified}}</span></li>
        <li>Stories checked for Plagiarism - <span class="digit1">{{summary.storiesWithCheckedPlagiarism}}</span></li>
        <li>Photo Gallery - <span class="digit1">{{summary.photoGalleryStoriesPublished}}</span></li>
        <li>Android App - <span class="digit1">{{summary.androidStoriesNotified}}</span></li>
        <li>Premium Stories filed - <span class="digit1">{{summary.premiumStories}}</span></li>
        <li>Web Stories - <span class="digit1">{{summary.webStoriesPublished}}</span></li>
        <li class="stories-field">iOS App - <span class="digit1">{{summary.iosStoriesNotified}}</span></li>
        <li>Videos - <span class="digit1">{{summary.videosStoriesPublished}}</span></li>
      </ul>
    </div>
    <ng-container *ngIf="selectedTab === 'last24hours'">
      <div class="tabcontainer">
        <div class="searchBlock">
          <div class="filterSection spImg">
            <i class="icon-filter"></i>
            <div class="fliterBlock">
              <ul class="filterOption">
                <ng-container *ngIf="filterList && facets">
                  <ng-container *ngFor="let filter of filterList;let i = index">
                    <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                      <filter [filterType]="filter.type" [displayName]="filter.name"
                        [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                        [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                        [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
                    </li>
                    <span #moreButtonEl tabindex="0"
                      [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                      (click)="(showMore = !showMore)" *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less'
                      : 'more'}}</span>
                  </ng-container>
                </ng-container>
              </ul>
            </div>
          </div>

        </div>
        <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableSectionHourTable')">Section Hour Pivot</button>
          <div class="tableFixHead" *ngIf="enableAndDisableSectionHourTable">
            <table>
              <thead>
                <tr>
                  <th class="stickL">Section/ Hour</th>
                  <th class="wide-head" *ngFor="let data of hourColumn; let i = index">{{ data }}-{{hour[i]}}</th>
                </tr>
              </thead>
              <p class="no-data-available" *ngIf="getKeysArray && getKeysArray.length === 0">No Data Available</p>
              <tbody *ngIf="getKeysArray && getKeysArray.length>0"> 
                <tr  *ngFor="let key of getKeysArray">
                  <th class="stickL" >{{key}}</th>
                  <ng-container *ngFor="let value of hourColumn">
                    <td class="wide">{{ data | custom:key:value }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>  
          <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableUserHourTable')">User Hour Pivot</button> 
          <div class="tableFixHead" *ngIf="enableAndDisableUserHourTable">
            <table>
              <thead>
                <tr>
                  <th class="stickL">User/ Hour</th>
                  <th class="wide-head" *ngFor="let data of hourColumn; let i = index">{{ data }}-{{hour[i]}}</th>
                </tr>
              </thead>
              <p class="no-data-available" *ngIf="userKeyArray && userKeyArray.length === 0">No Data Available</p>
              <tbody *ngIf="userKeyArray && userKeyArray.length>0">
                <tr  *ngFor="let key of userKeyArray">
                  <th class="stickL" >{{key}}</th>
                  <ng-container *ngFor="let value of hourColumn">
                    <td class="wide">{{ userDataResponse | custom:key:value }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>  
          <button type="button" class="collapsible" (click)="expandCollapsTable('enableNotificationHourPivot')">Section Notifications Hour Pivot</button> 
          <div class="tableFixHead" *ngIf="enableNotificationHourPivot">
            <table>
              <thead>
                <tr>
                  <th class="stickL">Notification/ Hour  <br>Web/Android/IOS</th>
                  <th class="wide-head" *ngFor="let data of hourColumn; let i = index">{{ data }}-{{hour[i]}}</th>
                </tr>
              </thead>
              <p class="no-data-available" *ngIf="notificationKeyArray && notificationKeyArray.length === 0">No Data Available</p>
              <tbody *ngIf="notificationKeyArray && notificationKeyArray.length>0">
                <tr  *ngFor="let key of notificationKeyArray">
                  <th class="stickL" >{{key}}</th>
                  <ng-container *ngFor="let value of hourColumn">
                    <td class="wide">{{ notificationDataResponse | custom:key:value }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>  
      </div>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'last30days'">
        <div class="tabcontainer">
          <div class="searchBlock">

            <div class="filterSection spImg">
              <i class="icon-filter"></i>
              <div class="fliterBlock">
                <ul class="filterOption">
                  <ng-container *ngIf="filterList && facets">
                    <ng-container *ngFor="let filter of filterList;let i = index">
                      <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                        <filter [filterType]="filter.type" [displayName]="filter.name"
                          [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                          [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                          [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
                      </li>
                      <span #moreButtonEl tabindex="0"
                        [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                        (click)="(showMore = !showMore)" *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ?
                        'less'
                        : 'more'}}</span>
                    </ng-container>
                  </ng-container>
                </ul>
              </div>
            </div>
   
          </div>
          <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableSectionDateTable')">Section Date Pivot</button>
            <div class="tableFixHead" *ngIf="enableAndDisableSectionDateTable">
              <table>
                <thead>
                  <tr>
                    <th class="stickL">Section/ Date</th>
                    <th class="wide-head" *ngFor="let data of dateColumn">{{ data }}</th>
                  </tr>
                </thead>
                <p class="no-data-available" *ngIf="getKeysArray && getKeysArray.length === 0">No Data Available</p>
                <tbody *ngIf="getKeysArray && getKeysArray.length>0">
                  <tr  *ngFor="let key of getKeysArray">
                    <th class="stickL">{{key}}</th>
                    <ng-container *ngFor="let value of dateColumn">
                      <td class="wide">{{ data | custom:key:value }}</td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
            <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableUserDateTable')">User Date Pivot</button>
              <div class="tableFixHead" *ngIf="enableAndDisableUserDateTable">
                <table>
                  <thead>
                    <tr>
                      <th class="stickL">User/ Date</th>
                      <th class="wide-head" *ngFor="let data of dateColumn">{{ data }}</th>
                    </tr>
                  </thead>
                  <p class="no-data-available" *ngIf="userKeyArray && userKeyArray.length === 0">No Data Available</p>
                  <tbody *ngIf="userKeyArray && userKeyArray.length>0">
                    <tr  *ngFor="let key of userKeyArray">
                      <th class="stickL">{{key}}</th>
                      <ng-container *ngFor="let value of dateColumn">
                        <td class="wide">{{ userDataResponse | custom:key:value }}</td>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </div>
              <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableNotificationDateTable')">Notification Date Pivot</button>
                <div class="tableFixHead" *ngIf="enableAndDisableNotificationDateTable">
                  <table>
                    <thead>
                      <tr>
                        <th class="stickL">Notification/ Date <br>Web/Android/IOS</th>
                        <th class="wide-head" *ngFor="let data of dateColumn">{{ data }}</th>
                      </tr>
                    </thead>
                    <p class="no-data-available" *ngIf="notificationKeyArray && notificationKeyArray.length === 0">No Data Available</p>
                    <tbody *ngIf="notificationKeyArray && notificationKeyArray.length>0">
                      <tr  *ngFor="let key of notificationKeyArray">
                        <th class="stickL">{{key}}</th>
                        <ng-container *ngFor="let value of dateColumn">
                          <td class="wide">{{ notificationDataResponse | custom:key:value }}</td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedTab === 'daterange'">
      <div *ngIf="!isGenerateReportClicked">Please select a date range.</div>
      <div *ngIf="isGenerateReportClicked" class="tabcontainer">
        <div class="searchBlock">

          <div class="filterSection spImg">
            <i class="icon-filter"></i>
            <div class="fliterBlock">
              <ul class="filterOption">
                <ng-container *ngIf="filterList && facets">
                  <ng-container *ngFor="let filter of filterList;let i = index">
                    <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                      <filter [filterType]="filter.type" [displayName]="filter.name"
                        [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                        [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                        [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
                    </li>
                    <span #moreButtonEl tabindex="0"
                      [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                      (click)="(showMore = !showMore)" *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ?
                      'less'
                      : 'more'}}</span>
                  </ng-container>
                </ng-container>
              </ul>
            </div>
          </div>
 
        </div>
        <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableSectionDateTable')">Section Date Pivot</button>
          <div class="tableFixHead" *ngIf="enableAndDisableSectionDateTable">
            <table>
              <thead>
                <tr>
                  <th class="stickL">Section/ Date</th>
                  <th class="wide-head" *ngFor="let data of dateRangeColumn">{{ data }}</th>
                </tr>
              </thead>
              <p class="no-data-available" *ngIf="getKeysArray && getKeysArray.length === 0">No Data Available</p>
              <tbody *ngIf="getKeysArray && getKeysArray.length>0">
                <tr  *ngFor="let key of getKeysArray">
                  <th class="stickL">{{key}}</th>
                  <ng-container *ngFor="let value of dateRangeColumn">
                    <td class="wide">{{ data | custom:key:value }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
          <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableUserDateTable')">User Date Pivot</button>
            <div class="tableFixHead" *ngIf="enableAndDisableUserDateTable">
              <table>
                <thead>
                  <tr>
                    <th class="stickL">User/ Date</th>
                    <th class="wide-head" *ngFor="let data of dateRangeColumn">{{ data }}</th>
                  </tr>
                </thead>
                <p class="no-data-available" *ngIf="userKeyArray && userKeyArray.length === 0">No Data Available</p>
                <tbody *ngIf="userKeyArray && userKeyArray.length>0">
                  <tr  *ngFor="let key of userKeyArray">
                    <th class="stickL">{{key}}</th>
                    <ng-container *ngFor="let value of dateRangeColumn">
                      <td class="wide">{{ userDataResponse | custom:key:value }}</td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
            <button type="button" class="collapsible" (click)="expandCollapsTable('enableAndDisableNotificationDateTable')">Notification Date Pivot</button>
              <div class="tableFixHead" *ngIf="enableAndDisableNotificationDateTable">
                <table>
                  <thead>
                    <tr>
                      <th class="stickL">Notification/ Date <br>Web/Android/IOS</th>
                      <th class="wide-head" *ngFor="let data of dateRangeColumn">{{ data }}</th>
                    </tr>
                  </thead>
                  <p class="no-data-available" *ngIf="notificationKeyArray && notificationKeyArray.length === 0">No Data Available</p>
                  <tbody *ngIf="notificationKeyArray && notificationKeyArray.length>0">
                    <tr  *ngFor="let key of notificationKeyArray">
                      <th class="stickL">{{key}}</th>
                      <ng-container *ngFor="let value of dateRangeColumn">
                        <td class="wide">{{ notificationDataResponse | custom:key:value }}</td>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </div>
      </div>
  </ng-container>
  </div>
</div>

